import { render, staticRenderFns } from "./blockTitle.vue?vue&type=template&id=0cc688c1&scoped=true"
import script from "./blockTitle.vue?vue&type=script&lang=js"
export * from "./blockTitle.vue?vue&type=script&lang=js"
import style0 from "./blockTitle.vue?vue&type=style&index=0&id=0cc688c1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc688c1",
  null
  
)

export default component.exports